/**
 * Input Schema of Responsavel
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {Responsavel} from '@/model/resource/Responsavel'
import InputTipoDocumento from '@/components/InputTipoDocumento.vue'
import {ValidatorHelper} from '@/helpers/ValidatorHelper'
import {debounce} from 'lodash'

export class InputResponsavelSchema extends Schema {
  formUpdateExpiringDate = ['dataVencimento']

  readonly name = 'InputResponsavel'

  debounceOutroDocumento = debounce(
    async (documento: string | null) =>
      await Responsavel.existDocument(documento),
    250
  )

  readonly fieldSet: FieldSet<Responsavel> = {
    loginPorDocumento: (schema): FieldComponent => ({
      is: InputTipoDocumento,
      bind: {
        model: schema.model,
        label: this.translateFrom(schema.fieldName),
        class: 'col-span-2',
      },
      on: {
        inputDocument: async () => {
          if (schema.model.loginPorDocumento) {
            if (
              schema.model.cnpj?.length == 11 ||
              schema.model.cnpj?.length == 14
            ) {
              if (
                ValidatorHelper.isCnpj(schema.model.cnpj) ||
                ValidatorHelper.isCpf(schema.model.cnpj)
              ) {
                await Responsavel.existDocument(schema.model.cnpj)
              }
            }
          } else {
            if (schema.model.outroDocumento) {
              await this.debounceOutroDocumento(schema.model.outroDocumento)
            }
          }
        },
      },
    }),
    razaoSocial: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 255,
        inputClass: 'uppercase',
        label: this.translateFrom(schema.fieldName),
      },
    }),
    nomeFantasia: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 255,
        inputClass: 'uppercase',
        label: this.translateFrom(schema.fieldName),
      },
    }),
    nomeContato: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 255,
        inputClass: 'uppercase',
        label: this.translateFrom(schema.fieldName),
      },
    }),
    telefone: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        inputClass: 'uppercase',
        type: 'mask',
        maskPreset: 'phone',
        label: this.translateFrom(schema.fieldName),
        validation: 'phone',
      },
    }),
    email: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        inputClass: 'uppercase',
        type: 'email',
        label: this.translateFrom(schema.fieldName),
        validation: 'email',
      },
    }),
    dataVencimento: (schema): FieldComponent => ({
      is: Component.InputDate,
      bind: {
        label: this.translateFrom(schema.fieldName),
      },
    }),
    dominiosAutorizados: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        label: this.translateFrom(schema.fieldName),
        placeholder: '@dominio1.com,@dominio2.com',
        maxlength: 1023,
        rows: 3,
        validation: 'required|email_domains',
      },
    }),
  }
}
